import EarlyRepaymentScreen from "@/modules/early-repayment/views/early-repayment-screen";
import type { CheckoutSession } from "@/types";

interface EarlyRepaymentPageProps {
  onCheckoutFetched: (session: CheckoutSession) => void;
}

export default function EarlyRepaymentPage({
  onCheckoutFetched,
}: EarlyRepaymentPageProps) {
  return <EarlyRepaymentScreen onSessionFetched={onCheckoutFetched} />;
}
